<template>
  <button
    :type="type"
    :disabled="disabled || isLoading"
    :class="[
            getButtonTypeClasses(),
            disabled ? 'opacity-50 cursor-not-allowed' : '',
            'relative',
            isSmall ? 'py-[6px]' : 'py-[16px]'
        ]"
    class="text-sm font-medium px-[20px]"
    @click="handleClick"
  >
    <div v-if="isLoading" class="absolute inset-0 flex items-center justify-center">
      <div class="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
    </div>
    <div :class="{ 'invisible': isLoading }">
      <span v-if="iconLeft" class="mr-2 text-sm font-normal">
              <i :class="iconLeft" class="fas"></i>
          </span>
      {{ title }}
      <span v-if="iconRight" class="ml-2 text-sm font-normal">
              <i :class="iconRight" class="fas"></i>
          </span>
    </div>
  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue';

type ButtonType = 'Primary' | 'Secondary' | 'Critical';

interface Props {
    title: string;
    type?: "button" | "reset" | "submit" | undefined;
    iconLeft?: string;
    iconRight?: string;
    disabled?: boolean;
    buttonType?: ButtonType;
    isLoading?: boolean;
    isSmall?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    title: "",
    iconLeft: "",
    iconRight: "",
    disabled: false,
    buttonType: 'Primary',
    type: "button",
    isLoading: false
});

const getButtonTypeClasses = () => {
    switch (props.buttonType) {
        case 'Primary':
            return 'bg-action text-inverse-emphasis';
        case 'Secondary':
            return 'bg-white text-action border border-action';
        case 'Critical':
            return 'bg-white border border-critical text-critical';
        default:
            return 'bg-action text-inverse-emphasis';
    }
};

const isDebouncing = ref(false);


const emit = defineEmits(['click']);

const handleClick = (event: Event) => {
  if (isDebouncing.value) return;
  
  isDebouncing.value = true;
  emit('click', event);
  
  setTimeout(() => {
    isDebouncing.value = false;
  }, 500);
};
</script>
